var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileLocation.jinja');
require('./MemberProfileLocation.less');

var Inner = require('front/components/MemberProfile/MemberProfileLocationInner');
var Runtime = require('front/components/MemberProfile/MemberProfileLocationInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'updateBlock');

        window.app.vent.on('MemberProfile--updateLocation', this.updateBlock);

        this.Inner = new Inner({
            el: this.$('.MemberProfileLocationInner')[0]
        });

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfile--updateLocation', this.updateBlock);

        this.Inner.deactivate();
        delete this.Inner;

        return Base.prototype.deactivate.call(this, params);
    },


    updateBlock: function (memberId) {
        this.Inner.deactivate();
        delete this.Inner;

        var data = window.app.data.members[memberId];

        var $template = $(Runtime.render({
            data: window.app.data.members[memberId],
            isOwner: window.app.settings.member == memberId
        }));

        this.$('.MemberProfileLocation-wrapper').html($template);

        this.Inner = new Inner({
            el: this.$('.MemberProfileLocationInner')[0]
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileLocation.js
// module id = 198
// module chunks = 0